/**
 * API client for leaderboard data
 * All data fetched from backend API endpoints
 * NO direct access to Lexicon Proxy
 */

import { config } from '../config';
import type { LeaderboardSinsResponse, LeaderboardStatsResponse } from '../types';

/**
 * Fetch overall leaderboard statistics
 */
export async function fetchLeaderboardStats(): Promise<LeaderboardStatsResponse> {
  const response = await fetch(`${config.apiUrl}/api/leaderboard/stats`);

  if (!response.ok) {
    throw new Error(`Failed to fetch stats: ${response.statusText}`);
  }

  return response.json();
}

/**
 * Fetch sin rankings with confession counts
 */
export async function fetchSinRankings(): Promise<LeaderboardSinsResponse> {
  const response = await fetch(`${config.apiUrl}/api/leaderboard/sins`);

  if (!response.ok) {
    throw new Error(`Failed to fetch sin rankings: ${response.statusText}`);
  }

  return response.json();
}
